import { Directive } from '@angular/core';
import { ComponentCanDeactivate } from 'projects/sepidz-web-framework/src/lib/can-deactivate/component-can-deactivate';
import { Observable } from 'rxjs';

@Directive()
export class FormCanDeactivate extends ComponentCanDeactivate {
  canDeactivate(): boolean | Observable<boolean> {
    return true;
  }
}
